module.exports = __webpack_public_path__ + "88fa5ec9.png";